module.exports = __webpack_public_path__ + "static/media/0011.d7d323b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0011.mp3
// module id = vY+g
// module chunks = 0